"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.LiveStream = void 0;
var dvr_1 = require("./dvr");
var geo_1 = require("./geo");
var playback_url_1 = require("./playback-url");
var publish_endpoint_1 = require("./publish-endpoint");
var LiveStream = /** @class */ (function () {
    function LiveStream(data) {
        this.id = null;
        this.id = data.id;
        this.publishEndpoint = new publish_endpoint_1.PublishEndpoint(data.publishEndpoint);
        this.playbackUrls = data.playbackUrls.map(function (playbackUrl) { return new playback_url_1.PlaybackUrl(playbackUrl); });
        this.streamType = data.streamType;
        this.duration = data.duration;
        this.connectTimeout = data.connectTimeout;
        this.reconnectTimeout = data.reconnectTimeout;
        this.enforcedWidth = data.enforcedWidth;
        this.enforcedHeight = data.enforcedHeight;
        this.maxPublishDuration = data.maxPublishDuration;
        this.state = data.state;
        this.stateNotification = data.stateNotification;
        this.dvr = data.dvr ? new dvr_1.Dvr(data.dvr) : undefined;
        this.publisherGeo = data.publisherGeo
            ? new geo_1.Geo(data.publisherGeo)
            : undefined;
        this.dateCreated = data.dateCreated;
        this.dateUpdated = data.dateUpdated;
    }
    return LiveStream;
}());
exports.LiveStream = LiveStream;
//# sourceMappingURL=live-stream.js.map